export const cities = [
    {
        name: 'Coventry',
        description: 'YEHHHH',
        train : {
            cost: '£35+',
            time: '2 hrs - 2 hrs 30 min',
            steps: [
                {
                    number: 1,
                    location: 'Heathrow Underground Station',
                    by: 'Tube'
                },
                {
                    number: 2,
                    location: 'London Euston Station',
                    by: 'Train'
                },
                {
                    number: 3,
                    location: 'Coventry',
                    by: 'Bus/Uber'
                },
                {
                    number: 4,
                    location: 'Accommodation',
                },
            ]
        },
        bus : {
            cost: '£25+',
            time: '3 hrs - 4 hrs',
            steps: [
                {
                    number: 1,
                    location: 'Heathrow Airport Central Bus Station',
                    by: 'Coach'
                },
                {
                    number: 2,
                    location: 'Coventry Pool Meadow Bus Station',
                    by: 'Bus/Uber'
                },
                {
                    number: 3,
                    location: 'Accommodation',
                },
            ]
        },
        taxi : {
            cost: '£120 for 4 passengers',
            time: '1hr 30min - 2hrs',
            postCode: 'CV1 4FQ',
            steps: [
                {
                    number: 1,
                    location: 'Heathrow Airport Central Bus Station',
                    by: 'Coach'
                },
                {
                    number: 2,
                    location: 'Coventry Pool Meadow Bus Station',
                    by: 'Bus/Uber'
                },
                {
                    number: 3,
                    location: 'Accommodation',
                },
            ]
        },

    },
    {
        name: 'On Campus',
        description: 'YEHHHH',
        train : {
            cost: '£35+',
            time: '2 hrs - 2 hrs 30 min',
            steps: [
                {
                    number: 1,
                    location: 'Heathrow Underground Station',
                    by: 'Tube'
                },
                {
                    number: 2,
                    location: 'London Euston Station',
                    by: 'Train'
                },
                {
                    number: 3,
                    location: 'Coventry',
                    by: 'Bus/Uber'
                },
                {
                    number: 4,
                    location: 'Accommodation',
                },
            ]
        },
        bus : {
            cost: '£20+',
            time: '3 hrs 30 mins - 5 hrs',
            steps: [
                {
                    number: 1,
                    location: 'Heathrow Airport Central Bus Station',
                    by: 'Coach'
                },
                {
                    number: 2,
                    location: 'Coventry Pool Meadow Bus Station',
                    by: 'Bus/Uber'
                },
                {
                    number: 3,
                    location: 'Accommodation',
                },
            ]
        },
        taxi : {
            cost: '£130 for 4 passengers',
            time: '1hr 45min - 2hrs 15min',
            postCode: 'CV4 7ES',
            steps: [
                {
                    number: 1,
                    location: 'Heathrow Airport Central Bus Station',
                    by: 'Coach'
                },
                {
                    number: 2,
                    location: 'Coventry Pool Meadow Bus Station',
                    by: 'Bus/Uber'
                },
                {
                    number: 3,
                    location: 'Accommodation',
                },
            ]
        },

    },
    {
        name: 'Leamington Spa',
        description: 'YEHHHH',
        train : {
            cost: '£35+',
            time: '2 hrs - 2 hrs 30 min',
            steps: [
                {
                    number: 1,
                    location: 'Heathrow Underground Station',
                    by: 'Tube'
                },
                {
                    number: 2,
                    location: 'London Euston Station',
                    by: 'Train'
                },
                {
                    number: 3,
                    location: 'Coventry',
                    by: 'Bus/Uber'
                },
                {
                    number: 4,
                    location: 'Accommodation',
                },
            ]
        },
        bus : {
            cost: 'Not Available',
            time: 'Not Available',
            steps: [
                {
                    number: 1,
                    location: 'Heathrow Airport Central Bus Station',
                    by: 'Coach'
                },
                {
                    number: 2,
                    location: 'Coventry Pool Meadow Bus Station',
                    by: 'Bus/Uber'
                },
                {
                    number: 3,
                    location: 'Accommodation',
                },
            ]
        },
        taxi : {
            cost: '£120 for 4 passengers',
            time: '1hr 30min - 2hrs',
            postCode: 'CV31 2AU',
            steps: [
                {
                    number: 1,
                    location: 'Heathrow Airport Central Bus Station',
                    by: 'Coach'
                },
                {
                    number: 2,
                    location: 'Coventry Pool Meadow Bus Station',
                    by: 'Bus/Uber'
                },
                {
                    number: 3,
                    location: 'Accommodation',
                },
            ]
        },
    }
]

export const checkList = [
    {
        name: 'Passport'
    },
    {
        name: 'Visa document'
    },
    {
        name: 'IOM check document'
    },
    {
        name: 'CAS letter'
    },
    {
        name: 'Fill in Passenger Locator Form'
    },
    {
        name: 'Book a Covid Test for self-quarantine at UK'
    },
    {
        name: 'Covid-19 test result from Thailand'
    },
]

export const packing = [
    {
        name: 'Medicine (Make sure it is legal)'
    },
    {
        name: 'Mask'
    },
    {
        name: 'Around 10 Sets of Clothes'
    },
    {
        name: 'Sim card that is usable in UK'
    },
    {
        name: 'Contactless Debit/Credit Card'
    },
    {
        name: 'Cash (Around £250+)'
    },
    {
        name: 'Sweater or Jacket (It will be around 15°C at September)'
    },
]

export const questions = [
    {
        q: 'Are there any part-time job',
        a: 'Yes, most of the Thai student usually did the part-time job at nearby restaurant'
    },
    {
        q: 'How much money should I prepare per week',
        a: 'Excluding Accommodation fee, £150 should be more than enough depending on your lifestyle'
    },
    {
        q: 'How many Thai Students are there',
        a: 'There are around 30 undergraduates and around 70+ postgraduate Thai student'
    },
    {
        q: 'How expensive is food there?',
        a: 'Can be range from £7-£20, depending on the restaurant'
    },
    {
        q: 'How should I find accommodation (for second year and above)',
        a: 'There are plenty of accommodation choices where you can stay in student-accommodation, house, apartment, and more depending on your budget and preferred location. Try Searching google or look for real-estate agency nearby (There are plenty)'
    },
    {
        q: 'How long does it takes to go to large city such as London/Birmingham',
        a: 'London: around 1 hour | Birmingham: less than 30 minute'
    },
    {
        q: "Is it hard to find friend?",
        a: "No, people are very friendly here"
    },
    {
        q: 'How often do Thai Society meet each other',
        a: "During the past years, we have a weekly sports where Thai Society members will come to play badminton/basketball together. As for other activities such as partying, monthly would be fair to say"
    },


]